import React from 'react'
import { AppRoutes } from './app/routes'
import { Providers } from './app/providers'
import { CommandPalette } from './components/ai/command-palette'
import { ThemeInitializer } from '@/components/themes/ThemeInitializer'
import { useEntityProviders } from './app/entity-providers'
import { OfflineIndicator } from './components/common/OfflineIndicator'
import { useActivityTracker } from '@appic/hooks'
import { useSupabaseRootHashNormalize } from './app/useSupabaseRootHashNormalize'
import { useTenantBootstrap } from './app/useTenantBootstrap'
import { useErpPaletteActions } from './app/useErpPaletteActions'

/** Mounts the activity tracker singleton inside the router context */
function ActivityTracker() {
  useActivityTracker()
  return null
}

function App() {
  const [paletteOpen, setPaletteOpen] = React.useState(false)

  useEntityProviders()
  useSupabaseRootHashNormalize()
  useTenantBootstrap()
  useErpPaletteActions()

  return (
    <Providers>
      <ActivityTracker />
      <OfflineIndicator />
      <ThemeInitializer />
      {/* C04: Skip-to-content link for keyboard navigation */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50 focus:px-4 focus:py-2 focus:rounded-lg focus:bg-muted focus:text-foreground focus:outline-none"
      >
        Skip to content
      </a>
      <div className="min-h-screen overscroll-contain-y">
        <main id="main-content" tabIndex={-1} className="outline-none">
          <AppRoutes />
        </main>
        {/* Global UI infrastructure */}
        <CommandPalette isOpen={paletteOpen} onOpenChange={setPaletteOpen} />
      </div>
    </Providers>
  )
}

export default App
